export function formatStatus(status: string, t: (key: string) => string) {
  switch (status) {
    case "STATUS_UNSPECIFIED":
      return {
        name: t("travelStatus.UNSPECIFIED"),
        color: "#CF7822",
        bg: "#FFE7CFCC",
      };
    case "STATUS_PRE_BOOKED":
      return {
        name: t("travelStatus.PRE_BOOKED"),
        color: "#CF7822",
        bg: "#FFE7CFCC",
      };
    case "STATUS_BOOKED":
      return {
        name: t("travelStatus.BOOKED"),
        color: "#218C26",
        bg: "#DAFDEBCC",
      };
    case "STATUS_UPCOMING":
      return {
        name: t("travelStatus.UPCOMING"),
        color: "#218C26",
        bg: "#DAFDEBCC",
      };
    case "STATUS_BOOKING_IN_PROGRESS":
      return {
        name: t("travelStatus.BOOKING_IN_PROGRESS"),
        color: "#CF7822",
        bg: "#FFE7CFCC",
      };
    case "STATUS_IN_PROGRESS":
      return {
        name: t("travelStatus.IN_PROGRESS"),
        color: "#CF7822",
        bg: "#FFE7CFCC",
      };
    case "STATUS_COMPLETED":
      return {
        name: t("travelStatus.COMPLETED"),
        color: "#536471",
        bg: "#E8ECEFCC",
      };
    case "STATUS_CANCELLED":
      return {
        name: t("travelStatus.CANCELLED"),
        color: "#B04D56",
        bg: "#FFE0EACC",
      };
    default:
      return {
        name: t("travelStatus.UNKNOWN_STATUS"),
        color: "#218C26",
        bg: "#DAFDEBCC",
      };
  }
}
